export enum VideoProviderEnum {
    YOUTUBE = 'YOUTUBE',
    VIMEO = 'VIMEO',
    PROGRESSCENTER = 'PROGRESSCENTER',
}
